import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { CapabilityEngineService } from '../capabilityEngine.service';
import { RedirectService } from '../redirect/redirect.service';
import { TeamsListService } from './teams-list.service';

@Component({
    selector: 'app-teams-list',
    templateUrl: './teams-list.component.html',
    styleUrls: ['./teams-list.component.scss']
})
export class TeamsListComponent implements OnInit {

    sortKey: String;
    sortOrder: String;
    teamsList: any;
    pageNumber: number = 0;
    nextToken: String;
    curNextToken: String;
    searchText = '';

    constructor(
        private _teamsListService: TeamsListService,
        private _capabilityEngineService: CapabilityEngineService,
        private _activatedRoute: ActivatedRoute,
        private _redirectService: RedirectService
    ) { }

    ngOnInit() {

        const pathData = this._activatedRoute.data['_value'];
        if (this.canPerform(pathData.capabilities)) {
            this.onScroll();
            this.sortKey = 'name';
            this.sortOrder = 'asc';

        }
        // this._teamsListService.getAllTeams()
        //     .subscribe((result: any) => {
        //         this.teamsList = result.data;
        //         _.forEach(this.teamsList, (team: any) => {
        //             if (team.validUpto) {
        //                 const days: number = moment(team.validUpto).diff(moment.utc(), 'days');
        //                 if (days < 0) {
        //                     team.dueDays = 'passed';
        //                 } else {
        //                     team.dueDays = JSON.stringify(days);
        //                 }
        //             }
        //         });
        //     }, (err) => {
        //         console.log('err ', err);
        //     });
    }

    sort(key) {
        if (key === this.sortKey) {
            this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortKey = key;
            this.sortOrder = 'asc';
        }
    }

    canPerform(data) {
        return this._capabilityEngineService.canPerform(data);
    }

    onScroll() {
        this._teamsListService.performPagination(this.pageNumber)
            .subscribe((result: any) => {
                console.log(result, this.teamsList);
                if (!this.teamsList) {
                    this.teamsList = result.data;
                } else {
                    this.teamsList = _.union(this.teamsList, result.data);
                }
                this.pageNumber++;
            });
    }


}



// WEBPACK FOOTER //
// ./src/app/teams-list/teams-list.component.ts